// removed by extract-text-webpack-plugin
module.exports = {"root":"_3XQs52dQptvUBeQKTmima"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/Input/Group/Group.scss
// module id = ./node_modules/wix-style-react/dist/es/src/Input/Group/Group.scss
// module chunks = 0